import axios from 'axios';
import { useContext, useEffect } from 'react';
import keycloakContext from './Keycloak/KeycloakContext';

const UNAUTHORIZED = 401;

const axiosBasic = axios.create({
  baseURL: process.env.REACT_APP_BASIC_URL,
  timeout: 60000,
  headers: {},
});

interface Props {
  children: React.ReactNode;
}

const AxiosConfigProvider = (props: Props): any => {
  const token = localStorage.getItem('wso2') || '';
  const { children } = props;
  const { keycloak } = useContext(keycloakContext);
  axiosBasic.defaults.headers.Authorization = token ? `Bearer ${token}` : '';

  useEffect(() => {
    const requestInterceptorId = axiosBasic.interceptors.request.use(
      (request: any) => {
        request.params = {
          ...request.params,
          token: keycloak.token,
        };
        return request;
      },
      (e: any) => {
        return Promise.reject(e);
      },
    );

    const responseInterceptorId = axiosBasic.interceptors.response.use(
      (response: any) => {
        return response;
      },
      (e: any) => {
        if (e.response && e.response.status === UNAUTHORIZED) {
          if (keycloak.logout) {
            keycloak.logout();
          }
        }
        return Promise.reject(e);
      },
    );

    return () => {
      axiosBasic.interceptors.request.eject(requestInterceptorId);
      axiosBasic.interceptors.response.eject(responseInterceptorId);
    };
  }, [keycloak]);

  return children;
};

export default AxiosConfigProvider;
